import { useState } from "react";
import { useDebounce } from "use-debounce";

import PanelsLayout from "components/PanelsLayout";
import EmptyPanel from "components/EmptyPanel";

import LetterProjectsList from "./LetterProjectsList";
import OutgoingLettersList from "./OutgoingLettersList";
import styles from "./officialLetters.module.scss";

// Listy pism autora — port Magistratu (Kwantum.Documents.List):
//   /projekty-pism     — NormalProjectsList: pisma do momentu przekazania do wysyłki,
//   /wychodzace-pisma  — OutgoingDocumentsList: pismo → wygenerowane przesyłki ze statusem,
//                        dopóki wszystkie nie zostaną wysłane („Wychodzące pisma", żeby nie
//                        kolidowało z istniejącą skrzynką „Wychodzące").

interface Props {
  view: "projects" | "outgoing";
}

const OfficialLettersModule = ({ view }: Props) => {
  const [searchText, setSearchText] = useState("");
  const [debouncedText] = useDebounce(searchText, 300);

  return (
    <PanelsLayout
      title={view === "projects" ? "Projekty pism" : "Wychodzące pisma"}
      onChangeSearch={(text: string) => setSearchText(text)}
      leftPanel={
        <div className={styles.panel}>
          {view === "projects" ? (
            <LetterProjectsList searchText={debouncedText} />
          ) : (
            <OutgoingLettersList searchText={debouncedText} />
          )}
        </div>
      }
      hideRight={true}
      rightPanel={<EmptyPanel />}
      isSearchExpanded={true}
    />
  );
};

export default OfficialLettersModule;
